import { memo } from "react";
import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _IsUserPremiumFromPartners } from "@discovery/common-dplus/lib/state";
import { detectAdblock } from "../../../../../utils/adBlocker";
import { Link, LinkKind } from "../../../../atoms/link";
import { useWindowSize } from "../../../../../utils/hooks";
import * as styles from "./styles.css";
const RailAd = ({ bannerId, bannerAdPlaceholder, channelTitle, showTitle, genreCategory, }) => {
    const [isAdBlocked, setisAdBlocked] = useState(true);
    const [width] = useWindowSize();
    const isEmpty = () => {
        googletag.cmd.push(() => {
            googletag.pubads().addEventListener("slotRenderEnded", (event) => {
                const slot = event.slot;
                const id = slot.getSlotElementId() && slot.getSlotElementId().split("/")[2];
                try {
                    id === "banner_atf" &&
                        localStorage.setItem("isAdRendered", `${event.isEmpty}`);
                }
                catch (e) {
                    console.info(e);
                }
                setisAdBlocked(!event.empty);
            });
        });
    };
    const defineAdSlot = () => {
        googletag.cmd.push(() => {
            const w = window.innerWidth;
            let s2 = "";
            if (w > 1024) {
                s2 = "web";
            }
            else if (w <= 1024 && w >= 728) {
                s2 = "tablet";
            }
            else {
                s2 = "mobile";
            }
            let banner;
            if (w >= 728) {
                banner = googletag
                    .sizeMapping()
                    .addSize([1025, 0], [[342, 192]])
                    .addSize([728, 0], [[349, 196]])
                    .addSize([0, 0], [])
                    .build();
            }
            else {
                banner = googletag
                    .sizeMapping()
                    .addSize([1024, 0], [])
                    .addSize([750, 0], [])
                    .addSize([728, 0], [])
                    .addSize([0, 0], [160, 90])
                    .build();
            }
            googletag
                .defineSlot(`/21712083437/dplus/${s2}/${bannerId}`, [], bannerId)
                .defineSizeMapping(banner)
                .addService(googletag.pubads());
            channelTitle
                ? googletag.pubads().setTargeting("dplusChName", channelTitle)
                : "";
            showTitle && (showTitle === null || showTitle === void 0 ? void 0 : showTitle.length) > 1
                ? googletag.pubads().setTargeting("dplusShowName", showTitle)
                : "";
            genreCategory && (genreCategory === null || genreCategory === void 0 ? void 0 : genreCategory.length) > 1
                ? googletag.pubads().setTargeting("dplusGenre", genreCategory)
                : "";
        });
        isEmpty();
    };
    useEffect(() => {
        defineAdSlot();
        return () => {
            googletag.cmd.push(() => {
                googletag.destroySlots();
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const RenderAd = () => {
        const src = bannerAdPlaceholder && bannerAdPlaceholder.image;
        const bannerUrl = bannerAdPlaceholder && bannerAdPlaceholder.url;
        return bannerUrl ? (React.createElement(Link, { href: bannerUrl, kind: LinkKind.external, openInNewWindow: true },
            React.createElement("div", { className: isAdBlocked
                    ? width && width <= 699
                        ? styles.adsContainer
                        : styles.adContainer
                    : "" },
                bannerAdPlaceholder && isAdBlocked && src && (React.createElement(SonicImage, { image: src, imageSizes: {
                        default: [100, "vw"],
                        maxWidthMediaQueries: [
                            [699, "px", 120, "px"],
                            [1023, "px", 140, "px"],
                            [1439, "px", 180, "px"],
                            [2559, "px", 200, "px"],
                        ],
                    }, extraImageWidths: [160, 342, 349], className: styles.adsPlaceholder, fallbackImageSize: { width: 160 }, alt: "Ad" })),
                React.createElement("div", { id: bannerId, className: styles.adsWrapper },
                    React.createElement("script", null, googletag.cmd.push(() => {
                        googletag.display(bannerId);
                    })))))) : (React.createElement(React.Fragment, null));
    };
    return React.createElement(RenderAd, null);
};
export const Ads = memo(({ bannerAdProp, channelTitle, showTitle, genreCategory }) => {
    const [showAd, displayAd] = useState(false);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    useEffect(() => {
        detectAdblock().then((isDetected) => {
            displayAd(!isDetected);
        });
    }, []);
    return showAd &&
        bannerAdProp &&
        bannerAdProp.isAdsEnabled &&
        !isPremiumUserFromPartner ? (React.createElement(RailAd, { bannerId: bannerAdProp.bannerId, channelTitle: channelTitle, showTitle: showTitle, genreCategory: genreCategory, bannerAdPlaceholder: bannerAdProp.bannerAdPlaceholder })) : (React.createElement(React.Fragment, null));
});

